















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

interface SimplePaywallFeature {
  icon: string;
  title: string;
  description: string;
}

@Component({
  computed: {
    ...mapGetters('categorizedCourses', ['roughNumCourses']),
  },
})
export default class PaywallFeaturesList extends Vue {
  private readonly roughNumCourses!: string;

  private features: SimplePaywallFeature[] = [
    {
      icon: 'b-sprite-paywall-pix-key2',
      title: 'All Courses',
      description: `Unlock all ${this.roughNumCourses} courses to build quantitative intuition and expand your
        understanding of the world.`,
    },
  ];
}
